<template>
    <div class="news-main main">
		<div class="college-bg prelative">
            <img src="@/assets/images/jm_bg.jpg" class="prelative dblock" />
			<!-- <div class="pabsolute lms tright">
				<a href="https://zjiet.cjnep.net/lms/web" target="_blank" class="lms-a dinline-block tcenter">
					<div class="fs24 mb5">学习端入口</div>
					<div class="fmt tupper">Learning Entrance</div>
				</a>
			</div> -->
        </div>
        <div class="htmldiv pt25 pb25 clearfix">
            <router-view />
            <SideBar />
        </div>
    </div>
</template>
<script>
import SideBar from '@/components/common/SideBar'

export default {
    components: {
        SideBar
    }
}
</script>
<style scoped>
	.lms{
		left: 50%;
		bottom: 10px;
		transform: translateX(-50%);
		width: 1200px;
		

	}
	.lms-a{
		padding: 5px 40px;
		display: inline-block;
		background: var(--mcolor);
		color: #fff;
	}
	.lms-a:hover{
		  background: linear-gradient(to bottom, #609ae4, #3460d3);
	}
</style>